export const TRANSFER_FREQUENCY = {
	oneTime: {
		frequency: 'ONCE',
		display: 'one-time',
		quantified: 1,
	},
	daily: {
		frequency: 'DAILY',
		display: 'daily',
		quantified: 260,
	},
	weekly: {
		frequency: 'WEEKLY',
		display: 'weekly',
		quantified: 52,
	},
	biWeekly: {
		frequency: 'BI-WEEKLY',
		display: 'biweekly',
		quantified: 26,
	},
	monthly: {
		frequency: 'MONTHLY',
		display: 'monthly',
		quantified: 12,
	},
};

export const PITHY_AUTO_STASH_FREQUENCY_TEXT = {
	ONCE: '',
	DAILY: 'daily',
	WEEKLY: 'weekly',
	'BI-WEEKLY': 'biweekly',
	MONTHLY: 'monthly',
} as const;

export type PithyAutoStashFrequencyTextsKeys = keyof typeof PITHY_AUTO_STASH_FREQUENCY_TEXT;

export const SMART_SCHEDULE_MAPPINGS = {
	ONCE: 'oneTime',
	DAILY: 'daily',
	WEEKLY: 'weekly',
	'BI-WEEKLY': 'biWeekly',
	MONTHLY: 'monthly',
};

export const CLOSED_AASM_STATES = {
	closed: true,
};

export const RESTRICTED_REASON_CLOSED = 'CLOSED';
